import request from '@/utils/request'

// =====================================================（任务名称管理）==============================>>>>>>>>>>>>>>>>>>>>>
// 获取所有老师 teacher/all
export function ApiTeacherAll () {
  return request({
    url: `/teacher/all`,
    method: 'GET',
  })
}


// =====================================================（任务名称管理）==============================>>>>>>>>>>>>>>>>>>>>>
// 添加任务
export function ApiAddTask (data) {
  return request({
    url: `/taskName/add`,
    method: 'POST',
    data,
  })
}

// =====================================================（任务名称管理）==============================>>>>>>>>>>>>>>>>>>>>>
// 删除任务
export function ApiDelet (id) {
  return request({
    url: `/taskName/delete/${id}`,
    method: 'DELETE',
  })
}

// =====================================================（任务名称管理）==============================>>>>>>>>>>>>>>>>>>>>>
// 分页
export function ApiAddTaskList (params) {
  return request({
    url: `/taskName/page`,
    method: 'POST',
    data: {
      pageSize:params.pageSize,
      pageNo:params.pages,
      taskName:params.taskName
    }
  })
}

// =====================================================（任务名称管理）==============================>>>>>>>>>>>>>>>>>>>>>
// 更新
export function ApiAddTaskUpdate (params) {
  return request({
    url: `/taskName/update`,
    method: 'PUT',
    data: {
      id: params.id,
      taskUser: params.taskUser,
      taskName: params.taskName
    }
  })
}



// ================获取学生=====================================（代办任务管理）==============================>>>>>>>>>>>>>>>>>>>>>
export function ApiGetStudentList () {
  return request({
    url: `/student/getStudentList`,
    method: 'POST',
    data:{
      studentType: 0
    }
  })
}


// ==========================分页===========================（代办任务管理）==============================>>>>>>>>>>>>>>>>>>>>>
export function ApiGetTodoList (params) {
  return request({
    url: `/todo/page`,
    method: 'POST',
    data:{
      pageNo:params.pageNo,
      pageSize:params.pageSize,
      startTime:params.startTime,
      endTime:params.endTime,
      taskId:params.taskName,
      executiveTeacher:params.executiveTeacher,
      startExpirationDate: params.startExpirationDate,
      endExpirationDate: params.endExpirationDate,
      successPlan:params.successPlan,
      taskUser:params.taskUser,
      expirationDate:params.expirationDate,
      studentId: params.studentId,
      marketSuccess:params.marketSuccess,
      communicationId:params.communicationId,
      toDoType:params.toDoType,
    }
  })
}

// ==========================删除===========================（代办任务管理）==============================>>>>>>>>>>>>>>>>>>>>>
export function ApiTodoDelete (id) {
  return request({
    url: `/todo/delete/${id}`,
    method: 'DELETE',
  })
}

// ==========================更新===========================（代办任务管理）==============================>>>>>>>>>>>>>>>>>>>>>
export function ApiAddTodoUpdate (params) {
  return request({
    url: `/todo/update`,
    method: 'PUT',
    data: {
      executiveTeacher: params.executiveTeacher,
      studentId: params.studentId,
      taskUser: params.taskUser,
      taskId: params.taskId,
      expirationDate: params.expirationDate,
      id: params.id,
      taskDetail: params.taskDetail,
      // impData: params.impData,
      imp: params.imp,
      communicationId: params.communicationId,
      toDoType: params.toDoType,
      expirationStartDate:params.expirationStartDate,
      expirationEndDate:params.expirationEndDate,
      handlingResult:params.handlingResult,
    }
  })
}
// ========================添加=============================（代办任务管理）==============================>>>>>>>>>>>>>>>>>>>>>

export function ApiAddTodoTask (data) {
  return request({
    url: `/todo/add`,
    method: 'POST',
    data,
  })
}

// =======================任务列表=============================（代办任务管理）==============================>>>>>>>>>>>>>>>>>>>>>

export function ApiAddTodoall () {
  return request({
    url: `/taskName/all`,
    method: 'GET',
  })
}


// =======================销售完成状态=============================（代办任务管理）==============================>>>>>>>>>>>>>>>>>>>>>
export function markeStatus (data) {
  return request({
    url: `/todo/marketOver?id=${data.id}&status=${data.marketSuccess}`,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/apiTask.js